import React from 'react';

export type RenderFeedbackType = (flashMessage: ?FlashMessage) => void;
export type FeedbackContext = {
  renderFeedback: RenderFeedbackType,
};

export default React.createContext(() => {});
